import styled from "styled-components";

export const WhyCompWrapper = styled.div`
  .whySec_heading {
    max-width: 90%;
    margin: 0 auto;
  }
  .working_details_div {
    margin-top: 32px;
    position: relative;
    border-radius: 25px;
    overflow: hidden;
    padding: 60px 50px;
    @media (max-width: 1199px) {
      padding: 50px 30px;
      border-radius: 15px;
    }
    @media (max-width: 899px) {
      padding: 25px 20px;
      border-radius: 12px;
    }
    .whySec_bg {
      z-index: 1;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgb(9, 6, 10);
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .workDetails_row {
      position: relative;
      z-index: 2;
      margin: -9px;
      align-items: stretch;
      .workDetails_col {
        width: 50%;
        padding: 9px;
        height: auto;
        @media (max-width: 899px) {
          width: 100%;
        }
        .workDetails_col_inner {
          background: rgba(255, 255, 255, 0.08);
          border: 1px solid rgba(255, 255, 255, 1);
          box-shadow: 11px 16px 19.6px 5px rgba(0, 0, 0, 0.25);
          backdrop-filter: blur(9.45px);
          border-radius: 25px;
          padding: 35px 35px 35px 53px;
          height: 100%;
          @media (max-width: 1199px) {
            padding: 20px;
            border-radius: 12px;
          }
          @media (max-width: 899px) {
            padding: 15px;
          }
          * {
            color: rgba(255, 255, 255, 1);
          }
          h3 {
            font-size: 24px;
            margin-bottom: 25px;
            @media (max-width: 1199px) {
              font-size: 20px;
              margin-bottom: 12px;
            }
            @media (max-width: 899px) {
              font-size: 17px;
            }
          }
        }
      }
    }
  }
`;

export const CareerOpeningsCompWrapper = styled.div`
  .slider_cards_Wrap {
    margin-top: 35px;
    .slick-list {
      margin: -11.5px;
      .slick-track {
        display: flex;
        .slick-slide {
          height: auto;
          > div {
            height: 100%;
            .career_cards_col {
              padding: 11.5px;
              height: 100%;
              .carrer_slide_Card {
                cursor: auto;
                box-shadow: none;
                &:hover {
                  transform: none;
                }
              }
            }
          }
        }
      }
    }
  }
`;
